module.exports = __webpack_public_path__ + "static/media/qrcode-kefu.1858dda1.png";